import React from 'react';
import ResourceComponent from '../../common/ResourceComponent';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from './EmbeddableApi';
import {connect} from 'react-redux';
import {colorBlockFormatter, dollarsFormatter, impactFormatter, percentage} from '../../common/TableFormatters';
import {Badge, Button, Col, Row} from 'reactstrap';
import defaultImage from './utils/no_image.png';
import ShareButton from './utils/ShareButton';
import {getMaterialImageAlt, isFeatureFlagEnabled} from '../../common/Utils';

class EmbBundleItem extends ResourceComponent {
    state = {
        showTooltip: false,
        imagesStatus: {},
    };

    copyToClipboard = (id) => {
        const temp = document.createElement('textarea');
        document.body.appendChild(temp);
        temp.value = `https://${location.hostname}/bundles?item_id=${id}`;
        temp.select();
        document.execCommand('copy');
        this.setState({showTooltip: id},
            () => setTimeout(
                () => this.setState({showTooltip: false}), 3000),
        );
    };

    render() {
        const {showTooltip, imagesStatus} = this.state;
        const {
            settings, bundle_card_detail, bundle, index, ecommerceConnected, checkClaimed, onUnclaim,
            onClaim, onBundleClick, claimEnabled, sendEventData,
        } = this.props;
        const isCarbonSmartWoodEnabled = isFeatureFlagEnabled(this.props.profile, 'Carbon Smart Wood');

        return (
            <Col
                xs={12} sm={6} md={4} lg={3} xl={2} key={bundle.id}
                className={`mt-4 pointer align-content-center item-container ${index === 0 ? 'first-slab-item-margin ' : ' '}`}
                onClick={() => {
                    onBundleClick(bundle.id);
                    sendEventData('view_item', {
                        currency: 'USD',
                        value: bundle.price,
                        items: [{
                            item_name: `Pack: ${bundle.inventory_number}`,
                            price: bundle.price,
                        }],
                    });
                }}>
                <div
                    className='item-content'
                    style={{backgroundColor: settings.card_container_color ? settings.card_container_color : null}}>
                    {bundle_card_detail.sale_discount_index && bundle.discount && bundle.price !== bundle.base_price &&
                        <div style={{position: 'relative'}}>
                            <div
                                className='discount-banner'
                                style={{
                                    position: bundle_card_detail.show_images_index ? 'absolute' : 'inherit',
                                    opacity: bundle_card_detail.banner_transparency,
                                    backgroundColor: settings.banner_color_index ? settings.banner_color_index : 'transparent',
                                    color: settings.font_color_index ? settings.font_color_index : 'black',
                                }}>
                                <span className='sale'>SALE!</span>
                                <span className='discount'>
                                {percentage(bundle.price, bundle.price_no_discount)}
                            </span>
                            </div>
                        </div>
                    }

                    {bundle_card_detail.images_index &&
                        <React.Fragment>
                            <div className='image-container'>
                                <img
                                    alt={getMaterialImageAlt(bundle, bundle.picture)}
                                    src={bundle.picture && bundle.picture.large_url
                                        ? bundle.picture.large_url
                                        : (settings.bundle_default_pic_url ? settings.bundle_default_pic_url : defaultImage)}
                                    onLoad={() => {
                                        imagesStatus.id = true;
                                        this.setState({imagesStatus});
                                    }}
                                />
                            </div>
                        </React.Fragment>
                    }

                    <div className='body'>
                        <div className='item-data border-top'>
                            <Row className='m-2'>
                                {bundle_card_detail.species_index &&
                                    <Col xs={12} className='d-flex justify-content-center pl-0 pr-0 mr-0'>
                                    <span className='h5'>
                                        {settings.show_color_block ? colorBlockFormatter(bundle.name, bundle.color) : bundle.name}
                                    </span>
                                    </Col>
                                }
                                {bundle_card_detail.number_index &&
                                    <Col xs={12} className={'d-flex justify-content-center pl-0 pr-0'}>
                                        <Badge
                                            className={'float-right custom-badge'}
                                            color='light'>
                                            <b>{bundle.inventory_number}</b>
                                        </Badge>
                                    </Col>
                                }
                            </Row>
                            <div
                                className='pt-2 pb-2 pl-2 pr-2 border-top'>
                                {bundle_card_detail.source_type_index &&
                                    <Row>
                                        <Col xs={5} className='pr-0 mr-0'>
                                            <small>Source Type:</small>
                                        </Col>
                                        <Col xs={7} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.source_type}</b>
                                        </Col>
                                    </Row>
                                }
                                {isCarbonSmartWoodEnabled && bundle_card_detail.carbon_smart_wood_index &&
                                    <Row>
                                        <Col xs={4} className='pr-0 mr-0'>
                                            <small style={{whiteSpace: 'nowrap'}}>Carbon Smart Wood&trade;:</small>
                                        </Col>
                                        <Col xs={8} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.carbon_smart_wood ? 'Yes' : 'No'}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.thickness_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Thickness:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.thick}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.surfaced_thickness_index &&
                                    <Row>
                                        <Col xs={9} className='pr-0 mr-0'>
                                            <small>Surfaced Thickness:</small>
                                        </Col>
                                        <Col xs={3} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.surfaced_thickness}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.board_feet_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Board feet:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.total_bf}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.min_board_width_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Minimum Board Width</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.min_board_width}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.min_board_length_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Minimum Board Length:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.min_board_length}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.avg_board_length_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Average Board Length:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.avg_board_length}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.board_ft_price_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>BF price:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{dollarsFormatter(bundle.bf_price)}</b>
                                        </Col>
                                    </Row>
                                }
                                {bundle_card_detail.location_index &&
                                    <Row>
                                        <Col xs={4} className='pr-0 mr-0'>
                                            <small>Location:</small>
                                        </Col>
                                        <Col xs={8} className='pl-1 text-right'>
                                            <b className='h5'>{bundle.location}</b>
                                        </Col>
                                    </Row>
                                }
                                {settings.show_carbon_impact &&
                                    <Row>
                                        <Col xs={6} className='pr-0 mr-0'>
                                            <small>Carbon Impact:</small>
                                        </Col>
                                        <Col xs={6} className='pl-1 text-right'>
                                            <b className='h5'>{impactFormatter(bundle.carbon_impact_mt)}</b>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    {bundle_card_detail.share_button_index &&
                                        <ShareButton item={bundle} showTooltip={showTooltip}
                                                     copyToClipboard={this.copyToClipboard} />
                                    }
                                </Row>
                            </div>
                        </div>
                        <Row
                            className='m-0 item-summary p-3 pt-0 border-top align-self-end'>
                            {bundle_card_detail.price_index &&
                                <Col xs={12} className='d-inline-block p-1 text-right d-flex justify-content-center'>
                                    {bundle_card_detail.discount_label_index && bundle.discount && bundle.price !== bundle.base_price ?
                                        <div className='discount-price'>
                                            <h3 style={{fontSize: bundle_card_detail.discount_font_size_index}}
                                                className='discounted-price'>{bundle.price ? dollarsFormatter(bundle.price) : ''}
                                            </h3>
                                            <h4 style={{fontSize: bundle_card_detail.price_font_size_index}}
                                                className='base_price'>
                                                {bundle.price ? dollarsFormatter(bundle.price_no_discount) : ''}
                                            </h4>
                                        </div> :
                                        <h3 style={{fontSize: bundle_card_detail.price_font_size_index}}
                                            className='m-0'>{bundle.price ? dollarsFormatter(bundle.price) : ''}
                                        </h3>
                                    }
                                </Col>
                            }
                            {(claimEnabled || (!claimEnabled && ecommerceConnected)) && bundle.for_sale &&
                                <Col
                                    className='p-1 m-0 d-flex justify-content-center'>
                                    {checkClaimed(bundle)
                                        ? <Button
                                            size='sm' color='info'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onUnclaim(bundle);
                                            }}>
                                            {claimEnabled ? 'ON HOLD' : 'In cart'}
                                        </Button>
                                        : <Button
                                            size='sm' color='danger'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onClaim(bundle);
                                            }}>
                                            {claimEnabled ? 'Claim Item' : 'Add to Cart'}
                                        </Button>
                                    }
                                </Col>
                            }
                        </Row>
                    </div>
                </div>
            </Col>
        );
    }
}

EmbBundleItem.contextTypes = {
    router: PropTypes.object,
};

EmbBundleItem.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbBundleItem);


// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbBundleItem.js